"use client";

import { LayoutGrid } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useProductOnboardingNudge } from "@/hooks/use-product-onboarding-nudge";

export function ProductOnboardingNudge(): JSX.Element {
  const {
    open,
    handleCreateProduct,
    handleShowMeWhere,
    handleRemindLater,
    handleOpenChange,
  } = useProductOnboardingNudge();

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent elevated className="max-w-md">
        <DialogHeader>
          <div className="mb-2 flex justify-center">
            <div className="rounded-full bg-primary/10 p-3 text-primary">
              <LayoutGrid className="size-8" aria-hidden />
            </div>
          </div>
          <DialogTitle className="text-center text-xl">
            Introducing Products
          </DialogTitle>
          <DialogDescription className="text-center">
            Products map what you&apos;re building — functions, roles, goals,
            and features — so projects stay organized and easier to plan.
          </DialogDescription>
        </DialogHeader>

        <p className="text-center text-sm text-muted-foreground">
          Create your first product to connect existing projects or start from a
          GitHub repository.
        </p>

        <DialogFooter className="flex-col gap-2 sm:flex-col sm:space-x-0">
          <Button className="w-full" onClick={handleCreateProduct}>
            Create product
          </Button>
          <Button
            className="w-full"
            variant="outline"
            onClick={handleShowMeWhere}
          >
            Show me where
          </Button>
          <Button
            className="w-full"
            variant="ghost"
            onClick={handleRemindLater}
          >
            Remind me later
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
